module.exports = __webpack_public_path__ + "static/media/logNav_blu.fad72b58.svg";